var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/search.40f30067.png","uri@2x": __webpack_public_path__ + "static/media/search.265b50e0.png","uri@3x": __webpack_public_path__ + "static/media/search.5f5805d5.png",
    width: 18,
    height: 18
});